import { render } from "./HorsePreviewDates.vue?vue&type=template&id=de0fbed6"
import script from "./HorsePreviewDates.vue?vue&type=script&lang=js"
export * from "./HorsePreviewDates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__